import {OperatorType} from "./OperatorType.ts";
import {ConnectiveType} from "./ConnectiveType.ts";
import {Channel} from "../channel/Channel.ts";
import {DataField} from "../channel/DynamicDataParser.ts";

export enum RuleType {
    VALUE,  FIELD, OPERATOR, CONNECTOR, BRACKETS_OPEN, BRACKETS_CLOSE, END
}

export function getOperatorInfo(type: RuleType): (string | number)[] {
    switch (type) {
        case RuleType.CONNECTOR:
            return [0, "L"]
        case RuleType.OPERATOR:
            return [1, "L"]
    }
    return [-1, ""];
}

export class RuleEntry {
    private readonly ruleType: RuleType;
    private readonly char: string;
    private readonly operator?: OperatorType;
    private readonly value?: any;
    private readonly field?: any;
    private readonly connectiveType?: ConnectiveType;

    constructor(ruleType: RuleType, char: string, value: any) {
        this.ruleType = ruleType;
        this.char = char;

        switch (ruleType) {
            case RuleType.VALUE: {
                this.value = value;
                return;
            }
            case RuleType.FIELD: {
                this.field = value;
                return;
            }
            case RuleType.OPERATOR: {
                this.operator = value;
                return;
            }
            case RuleType.CONNECTOR: {
                this.connectiveType = value;
                return;
            }
        }
    }

    getRuleType() {
        return this.ruleType;
    }

    getChar() {
        return this.char;
    }

    getOperator() {
        return this.operator;
    }

    getValue() {
        return this.value;
    }

    getField() {
        return this.field;
    }

    getConnectiveType() {
        return this.connectiveType;
    }

    getResult(key_channel: Channel | null, row: number | null) {
        switch (this.ruleType) {
            case RuleType.VALUE:
                return this.value;
            case RuleType.FIELD: {
                if (key_channel == null || row == null) {
                    return null;
                }
                let offset = this.getField().indexOf("[") != -1 ? this.getField().indexOf("[") : this.getField().length;
                let fieldNum = Number(this.getField().substr(0, offset));
                if (this.getField().includes('[')) {
                    let num = this.getField().replace('[', '').replace(']', '').replace(`${fieldNum}`, '');
                    try {
                        if (key_channel.getRows()[row] == null) {
                            return null;
                        }
                        let field = key_channel.getRows()[row].find((a: DataField) => a.field == fieldNum);
                        if (field == null) {
                            return null;
                        }
                        if (field.value == "") {
                            return null;
                        }
                        return field.value[num - 1] || null;
                    } catch (e) {
                        return null;
                    }
                } else {
                    try {
                        let field: DataField = key_channel.getRows()[row].find((a: DataField) => a.field == fieldNum);
                        return field.value;
                    } catch (e) {
                        return null;
                    }
                }
            }
        }
    }
}